import React from 'react'
//import React, { Component } from 'react';
//import logo from './logo.svg';
//import './App.css';

//import Sample from './component/Sample'
import Container from './component/Container'
import './css/style.css'

class App extends React.Component {
  render() {
    return (
      <Container />
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js